import { isCategorySomeDepartment } from './categoryHelpers';

export const isSale = (urlQueryParams): boolean => {
  return urlQueryParams && urlQueryParams.on_sale === '1';
};

export const isNewIn = (urlQueryParams): boolean => {
  return urlQueryParams && Object.keys(urlQueryParams).length === 1 && urlQueryParams.sort_field === 'insert_time';
};

export const isGeneralNewInSale = ({ categoryName, urlQueryParams }): boolean => {
  return isCategorySomeDepartment(categoryName) || isSale(urlQueryParams) || isNewIn(urlQueryParams);
};
